import React from 'react';
import img from "../../images/story.jpg";

const About = () => {
    return (
        <div>
            <div className="pb-5">
                <h1 style={{ fontSize: "60px" }} className="mb-5 fw-bold">Get to know us</h1>
            </div>
            <div className="bg-success d-flex justify-content-evenly py-5">
                <div className="my-5 mx-5">
                    <h5 className=" fs-3 text-warning fw-bold">Our Story</h5>
                    <p className="fs-5 text-white mb-4">We started our journey at 2015. From the very begining, we're trying to deliver quality eduaction. As a Bangladeshi immigrant to the US, English Baksho CEO, Redoan knows the challenges that come with learning a new language and the value of practicing consistently rather than simply reading a textbook. That’s what inspired Redoan's idea for English Baksho, a free social platform for language learning.</p>
                    <p className="fs-5 text-white mb-4">
                        While working as a consultant, Redoan realized that an “Uber for language learning” would solve many of the problems English-language learners face. He eventually quit his job and partnered with his close friend Roome to start English Baksho.

                        Firstly we start shooting videos on different english topics and we were trying to teach in a funny way, so that a learners won't be bored whe he/she will watch our videos. We get huge support from our audience which we never expect. Then we upgrade our studio and hired some pepole to make our content better, help mass pepole.
                    </p>
                    <p className="fs-5 text-white mb-4">
                        Since those humble beginnings, we’ve grown a tiny bit. We start making paid courses so that we can consult our learners privately. Our team’s exploded from 2 to 100+, and we’ve reach over 100k+ learners and featured on some top Newspaper like Prothom Alo, Daily Star, kaler kantho etc.
                    </p>
                    <p className="fs-5 text-white">
                        And we’re just getting started.
                    </p>
                </div>
                <img className="my-5 rounded me-5" src={img} alt="" />
            </div>
        </div>
    );
};

export default About;